import { FC, useState } from 'react';

import { Enquiry, EnquiryStatus } from '@shared/api/enquiry/enquiry.interface';
import { Image } from '@shared/api/media/media.interface';
import ResizableBox from '@shared/components/ResizableBox';
import { Icon } from '@shared/components/icons';
import { formatDate } from '@shared/utils/formatDate';

const DURATION = 0.3;

const tagNames = {
  [EnquiryStatus.Todo]: '접수',
  [EnquiryStatus.Doing]: '접수',
  [EnquiryStatus.Done]: '답변완료',
};

interface IProps {
  enquiry: Enquiry | Enquiry<string, Image>;
  //* 내역 탭을 열었을 때 아직 안 읽은 답변이면 "새 답변" 표시
  isNew?: boolean;
}

const EnquiryCollapse: FC<IProps> = ({ enquiry, isNew = false }: IProps) => {
  const [isFold, setIsFold] = useState<boolean>(true);

  const { ChevronDown } = Icon();

  const onClick = () => setIsFold((curr) => !curr);

  return (
    <ResizableBox duration={DURATION}>
      <div
        onClick={onClick}
        className="flex cursor-pointer items-center justify-between p-3"
      >
        <div className="space-y-2">
          <div className="flex items-center space-x-3 text-xs">
            {/* Tag */}
            <div className="rounded-full px-2 py-1 theme-bg-5">
              {tagNames[enquiry.status]}
            </div>
            {isNew && (
              <div className="rounded-full bg-red-500 px-2 py-1 font-bold text-white">
                새 답변
              </div>
            )}
            {/* 문의한 날짜 */}
            <div>
              {formatDate(enquiry.createdAt, {
                dateSeparater: '.',
                contains: {
                  hours: true,
                  minutes: true,
                },
              })}
            </div>
          </div>
          <div>
            <h5 className="px-2">{enquiry.title}</h5>
          </div>
        </div>
        <div className={`transition-all duration-300 ${isFold ? '' : 'rotate-180'}`}>
          <ChevronDown />
        </div>
      </div>
      {!isFold && (
        <div className="px-4 text-xs">
          {/* 문의내용 */}
          <div className="border-y border-gray-200 bg-gray-50 px-2 py-2 leading-6">
            <p className="whitespace-pre-line break-keep">{enquiry.content}</p>
          </div>
          {/* 답변내용 */}
          <div className="space-y-2 px-2 py-2 leading-6">
            <h6 className="font-bold">답변내용</h6>
            {enquiry.answer ? (
              <p className="whitespace-pre-line break-keep">{enquiry.answer}</p>
            ) : (
              <p className="text-gray-400">아직 답변 전입니다. 답변이 달리면 여기에 표시됩니다.</p>
            )}
          </div>
        </div>
      )}
    </ResizableBox>
  );
};

export default EnquiryCollapse;
